import { IEventForm } from 'components/organisms/forms/event/EventForm';
import { ICreateEvent } from 'services/events/types';

export const eventFormToQuery = (eventForm: IEventForm): ICreateEvent => {
  const convertToISOString = (dateString: string): string => {
    if (dateString.includes('T')) {
      return dateString;
    }
    return new Date(dateString + 'T00:00:00.000Z').toISOString();
  };

  return {
    eventName: eventForm.name,
    startDate: convertToISOString(eventForm.startDate),
    endDate: convertToISOString(eventForm.endDate),
    labelRequests: eventForm.labels,
  };
};
  